/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneyAnalytics = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6.707 2v1h-.25a2.75 2.75 0 0 0 0 5.5h.25V10h-2v2h2v1h2v-1h.25a2.75 2.75 0 0 0 0-5.5h-.25V5h2V3h-2V2zm-.25 3h.25v1.5h-.25a.75.75 0 0 1 0-1.5zm2.25 5V8.5h.25a.75.75 0 1 1 0 1.5zm13 2h-8v2h4.471l-5.449 5.108-5.022-5.022L2 19.793l1.414 1.414 4.293-4.293 4.978 4.978 7.022-6.584V20h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMoneyAnalytics as MoneyAnalytics };
